/* Lifelike Artificial Plants — interactions
 * Vanilla JS, scoped to .tbw-ll. No deps.
 * Re-runs on Shopify section:load events for theme editor preview.
 */
(function () {
  'use strict';

  function initReveal(root) {
    var els = root.querySelectorAll('[data-reveal]:not([data-reveal-init])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); el.setAttribute('data-reveal-init', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); el.setAttribute('data-reveal-init', '1'); });
  }

  function initReveal2(root) {
    root.querySelectorAll('.reveal-canvas:not([data-init])').forEach(function (canvas) {
      canvas.setAttribute('data-init', '1');
      var handle = canvas.querySelector('.reveal-handle');
      var topImg = canvas.querySelector('img.top');
      function set(p) {
        p = Math.max(0, Math.min(100, p));
        canvas.style.setProperty('--reveal', p + '%');
        if (topImg) topImg.style.clipPath = 'inset(0 0 0 ' + p + '%)';
        if (handle) handle.style.left = p + '%';
      }
      function move(e) {
        var rect = canvas.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        set((x / rect.width) * 100);
      }
      function start(e) {
        e.preventDefault();
        move(e);
        function stop() {
          window.removeEventListener('mousemove', move);
          window.removeEventListener('mouseup', stop);
          window.removeEventListener('touchmove', move);
          window.removeEventListener('touchend', stop);
        }
        window.addEventListener('mousemove', move);
        window.addEventListener('mouseup', stop);
        window.addEventListener('touchmove', move, { passive: false });
        window.addEventListener('touchend', stop);
      }
      canvas.addEventListener('mousedown', start);
      canvas.addEventListener('touchstart', start, { passive: false });
      set(58);
    });
  }

  function initParallax(root) {
    var els = root.querySelectorAll('[data-parallax]:not([data-px-init])');
    if (!els.length) return;
    function update() {
      els.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var screenCenter = window.innerHeight / 2;
        var offset = (center - screenCenter) * speed;
        el.style.transform = 'translate3d(0, ' + (-offset).toFixed(2) + 'px, 0)';
      });
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    els.forEach(function (el) { el.setAttribute('data-px-init', '1'); });
    update();
  }

  function initFAQ(root) {
    root.querySelectorAll('.faq-item:not([data-init])').forEach(function (item) {
      item.setAttribute('data-init', '1');
      var q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        var list = item.closest('.faq-list');
        if (list) list.querySelectorAll('.faq-item.open').forEach(function (s) { if (s !== item) s.classList.remove('open'); });
        item.classList.toggle('open', !wasOpen);
      });
    });
  }

  function initFilters(root) {
    root.querySelectorAll('.filter-row:not([data-init])').forEach(function (row) {
      row.setAttribute('data-init', '1');
      var pills = row.querySelectorAll('.filter-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');
          var feedKey = pill.getAttribute('data-feed');
          if (!feedKey) return;
          var section = pill.closest('.tbw-ll-products') || pill.closest('section');
          if (!section) return;
          section.querySelectorAll('[data-feed-key]').forEach(function (feed) {
            feed.style.display = feed.getAttribute('data-feed-key') === feedKey ? '' : 'none';
          });
        });
      });
    });
  }

  function initMarquee(root) {
    root.querySelectorAll('.parallax-marquee .track:not([data-cloned])').forEach(function (track) {
      track.setAttribute('data-cloned', '1');
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  function initLeadForm(root) {
    root.querySelectorAll('[data-lead-form]:not([data-init])').forEach(function (form) {
      form.setAttribute('data-init', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var phone = form.getAttribute('data-whatsapp-phone') || '';
        var prefix = form.getAttribute('data-whatsapp-prefix') || '';
        var name = (form.querySelector('[name="name"]') || {}).value || '';
        var email = (form.querySelector('[name="email"]') || {}).value || '';
        var contact = (form.querySelector('[name="phone"]') || {}).value || '';
        var ptype = (form.querySelector('[name="project_type"]') || {}).value || '';
        var space = (form.querySelector('[name="space_brief"]') || {}).value || '';

        var msg = prefix + (prefix ? '\n\n' : '');
        if (name)    msg += 'Name: '    + name    + '\n';
        if (email)   msg += 'Email: '   + email   + '\n';
        if (contact) msg += 'Phone: '   + contact + '\n';
        if (ptype)   msg += 'Project: ' + ptype   + '\n';
        if (space)   msg += '\nDetails:\n' + space;

        var url = 'https://wa.me/' + encodeURIComponent(phone.replace(/[^0-9]/g, '')) + '?text=' + encodeURIComponent(msg.trim());
        window.open(url, '_blank', 'noopener');
      });
    });
  }

  function initScrollLinks(root) {
    root.querySelectorAll('[data-scroll-to]:not([data-init])').forEach(function (btn) {
      btn.setAttribute('data-init', '1');
      btn.addEventListener('click', function (e) {
        var target = btn.getAttribute('data-scroll-to');
        if (!target) return;
        var el = document.getElementById(target.replace(/^#/, ''));
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initReveal(root);
    initReveal2(root);
    initParallax(root);
    initFAQ(root);
    initFilters(root);
    initMarquee(root);
    initLeadForm(root);
    initScrollLinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
